import { ReactNode } from 'react';
import { StyledIconWrapperTypes } from '../wrappers/styles';
import { Wrapper } from './styles';

export type StatusIconProps = {
    icon: ReactNode;
    status?: StyledIconWrapperTypes;
    size?: number;
    borderRadius?: number;
};

const StatusIcon = ({ status = 'default', size = 48, borderRadius = 16, icon }: StatusIconProps) => {
    return (
        <Wrapper $size={size} $borderRadius={borderRadius} $status={status}>
            {icon}
        </Wrapper>
    );
};

export default StatusIcon;
